import React, { Component } from "react";
import "./Body.scss"

export default class Body extends Component {
  render() {
    console.log(this.props.page);
    return (
      <section className="section section-body" style={{
        display: this.props.page != null && "none"
      }}>
        <div className="padding">
          <div className="container">
            <div className="headline">
              <div className="head">
                <div>המשפחה שלכם מחכה כל השנה לחג השבועות</div>
                <div>בגלל מאכל אחד מיוחד שכולם אוהבים?</div>
              </div>
              <div className="desc">
                <div>שתפו אותנו במתכון המשפחתי שלכם לשבועות וצרפו תמונה של המנה. </div>
                <div>המשפחה שתגיע למקום הראשון תזכה ב-1,000 שקלים מתנת טרה.</div>
                <div>חמש המשפחות הנוספות יזכו במארז מוצרים של טרה והמתכונים שלהן יפורסמו באתר טרה.</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Body/Body.jsx